import { render } from "./wordcloud.vue?vue&type=template&id=5e60d456"
import script from "./wordcloud.vue?vue&type=script&lang=js"
export * from "./wordcloud.vue?vue&type=script&lang=js"

import "./wordcloud.vue?vue&type=style&index=0&id=5e60d456&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__